export default "__VITE_ASSET__9827b90d__"